module.exports = __webpack_public_path__ + "img/deep_sleeper--active.1ecebd25.svg";